<div class="form-row bloco-procedimentos-consultas">

  <div class="painel-tela-principal col-12 col-sm-12 col-md-12 col-lg-12">

    <h1>Agende sua consulta ou exame online</h1>

    <!-- <div *ngIf="includeMarcacaoConsultas()"> -->
    <div>
      <h3 class="lista-procedimentos col-sm-12 col-md-8 col-lg-6" style="float:none;margin:auto;">
        OFTALMOLOGIA
      </h3>
      <div *ngIf="exibirTextoOtorrino()">
        <h3 class="lista-procedimentos col-sm-12 col-md-8 col-lg-6" style="float:none;margin:auto;">
          OTORRINOLARINGOLOGIA
        </h3>
      </div>
      <div *ngIf="isCopeAgenda()">
        <h3 class="lista-procedimentos col-sm-12 col-md-8 col-lg-6" style="float:none;margin:auto;">
          TESTE DO OLHINHO / OFTALMOPEDIATRIA
        </h3>
      </div>
      <div *ngIf="!isCopeAgenda()">
        <h3 class="lista-procedimentos col-sm-12 col-md-8 col-lg-6" style="float:none;margin:auto;">
          OFTALMOPEDIATRIA / GLAUCOMA
        </h3>
      </div>
    </div>

    <div class="form-row" style="margin-top:20px;">
      <div class="col-sm-6 col-md-6 col-lg-6 col-6 form-group" style="justify-items: center;">
        <button mat-flat-button color="consultar" class="botao-agendar" (click)="irParaAgendamentoDeConsulta()">
          Consultas
        </button>
      </div>

      <div class="col-sm-6 col-md-6 col-lg-6 col-6 form-group" style="justify-items: center;">
        <button mat-flat-button color="consultar" class="botao-agendar" (click)="irParaAgendamentoDeExame()">
          Exames e Procedimentos
        </button>
      </div>
    </div>

    <div>

      <div *ngIf="!isCopeAgenda()" style="margin-top: 20px;">
        <h3 class="lista-procedimentos col-sm-12 col-md-8 col-lg-6"
          style="float:none;margin:auto;background-color: rgba(85, 86, 87, 0.234); border-radius: 5px;">
          <div style="color: #000000; text-shadow: 0 0 #ffffff00;">
            Os exames abaixo só podem ser marcados de forma presencial
          </div>
          <li>Angiografia fluorescente</li>
          <li>Teste ortóptico (exame de motilidade ocular) e exercícios ortópticos</li>
          <li>Gonioscopia</li>
          <li>Fotocoagulação a laser</li>
        </h3>
      </div>

      <div class="form-row d-flex align-items-stretch flex-wrap" *ngIf="isCopeAgenda()">
        <div class="col-sm-6 col-md-6 col-lg-6 col-6 form-group d-flex">
          <div class="box-especialidades h-100 w-100"
            style="margin:auto; background-color: rgba(0, 0, 0, 0.47); border-radius: 5px; padding:15px;">
            <div style="word-wrap: break-word;">
              <strong>SUBESPECIALIDADES</strong>
            </div>
            <div>Córnea</div>
            <div>Estrabismo</div>
            <div>Glaucoma</div>
            <div>Oftalmopediatria</div>
            <div>Plástica ocular</div>
            <div>Retina</div>
          </div>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-6 col-6 form-group d-flex">
          <div class="box-especialidades h-100 w-100"
            style="margin:auto; background-color: rgba(0, 0, 0, 0.47); border-radius: 5px; padding:15px;">
            <div><strong>EXAMES</strong></div>
            <div>Angiografia</div>
            <div>Gonioscopia</div>
            <div>Teste ortóptico</div>
            <div>Fotocoagulação a laser</div>
            <div>Outros</div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="includeUnidades()" class="unidades-link col-12 col-sm-12 col-md-12 col-lg-12" style="text-align-last: center;">
      <a [routerLink]="['/unidades']" class="nossas-unidades">
        Acesse aqui e conheça nossas Unidades!
      </a>
    </div>

    <div *ngIf="isCopeAgenda()" style="margin-top: 20px;" class="col-12">
      <div class="box-aviso" style="
      float: none;
      margin: auto;
      border-radius: 5px;
      background-color: white;
      padding: 20px;
      max-width:600px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    ">
        <h3 style="color:#333; margin-bottom:10px; text-align:center;">
          Pacientes dos planos IASSEPE e HAPVIDA
        </h3>
        <p style="color:#555;margin:0;">
          O agendamento da primeira consulta deve ser feito diretamente com o plano de saúde.
        </p>
      </div>
    </div>

  </div>

</div>